import React, { createContext, useContext, ReactNode } from 'react';

interface CallToActionContextType {
  callToActionLink?: string;
  callToActionText?: string;
}

const CallToActionCustomizationContext = createContext<CallToActionContextType | undefined>(undefined);

interface CallToActionProviderProps {
  children: ReactNode;
  callToActionLink?: string;
  callToActionText?: string;
}

export const CallToActionCustomizationProvider = ({
  children,
  callToActionLink,
  callToActionText,
}: CallToActionProviderProps): JSX.Element => {
  return (
    <CallToActionCustomizationContext.Provider value={{ callToActionLink, callToActionText }}>
      {children}
    </CallToActionCustomizationContext.Provider>
  );
};

export const useCallToActionCustomization = (): CallToActionContextType => {
  return useContext(CallToActionCustomizationContext) ?? {};
};
